import { article } from '@/types/articles';
import ArticleCard from '@/components/ArticleCard';
import ArticleCardSkeleton from '@/components/skeletons/ArticleCardSkeleton';
import Section from '@/components/elements/Section';
import { useIsMobile } from '@/hooks/useIsMobile';

interface RecentArticlesProps {
  articles: article[];
  background?: 'white' | 'grey';
}

function RecentArticles({ articles, background = 'grey' }: RecentArticlesProps) {
  const isMobile = useIsMobile();
  return (
    <Section
      background={background}
      title='Latest Articles'
      data-cy='recent-articles'
      description='Stay up to date: Explore the latest insights in the most recent articles.'
    >
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-6 mt-6 mb-4'>
        {articles.length > 0
          ? articles.map((article, index) => {
              return (
                <ArticleCard
                  key={article.id}
                  article={article}
                  imagePosition='top'
                  data-cy={`${article.isPaid ? 'paid' : 'free'}-article-card`}
                  background={index > 0 && isMobile ? background : background === 'grey' ? 'white' : 'grey'}
                  layout={index > 0 ? 'noImageMobile' : undefined}
                />
              );
            })
          : [0, 1, 2, 3, 4, 5].map((index) => (
              <ArticleCardSkeleton
                key={index}
                imagePosition='top'
                layout={index > 0 && isMobile ? 'noImageMobile' : undefined}
                background={index > 0 ? background : background === 'grey' ? 'white' : 'grey'}
              />
            ))}
      </div>
    </Section>
  );
}

export default RecentArticles;
